import classnames from 'classnames';
import s from './index.module.scss';

export const Input = ({ label, name, error, maxLength, value = '', ...InputProps }) => {
  return (
    <div className={s.wrapper}>
      <label className="f-small-accent" htmlFor={name}>
        {label}
      </label>
      <input
        type="text"
        id={name}
        name={name}
        value={value}
        maxLength={maxLength}
        className={classnames(
          s.input,
          error && s.input_error,
          'f-small-regular',
        )}
        {...InputProps}
      />
      <div className={s.bottom}>
        {error ? (
          <div className={classnames(s.error_message, 'f-small-regular')}>{error}</div>
        ) : (
          <div />
        )}
        {maxLength && (
          <div className={classnames(s.counter, 'f-small-regular', error && s.counter_limit)}>
            {value.length}/{maxLength}
          </div>
        )}
      </div>
    </div>
  );
};
